import Ajax from '../js/common/ajax';

export default {
	// 数据模型（业务数据源）
	definition: {
		simple: () => Ajax.get('/tripartite/definition/simple'),
		list: () => Ajax.get('/tripartite/definition'),
		save: (p) => Ajax.post('/tripartite/definition', p),
		update: (p) => Ajax.put('/tripartite/definition', p),
		delete: (id) => Ajax.delete(`/tripartite/definition/${id}`),
		exportConfig: (id) => Ajax.get(`/tripartite/definition/${id}/export`),
		exportAll: () => Ajax.get('/tripartite/definition/export-all'),
		importConfig: (formData) => Ajax.post('/tripartite/definition/import', formData)
	},
	// 凭证模板
	tpl: {
		list: (definitionId) => Ajax.get(`/tripartite/definition/${definitionId}/voucher-tpl`),
		load: (definitionId, id) => Ajax.get(`/tripartite/definition/${definitionId}/voucher-tpl/${id}`),
		save: (definitionId, p) => Ajax.post(`/tripartite/definition/${definitionId}/voucher-tpl`, p),
		delete: (definitionId, id) => Ajax.delete(`/tripartite/definition/${definitionId}/voucher-tpl/${id}`)
	},
	// 业务数据
	data: {
		page: (definitionId, p) => Ajax.post(`/tripartite/data/${definitionId}/page`, p),
		load: (definitionId, id) => Ajax.get(`/tripartite/data/${definitionId}/${id}`),
		save: (definitionId, p) => Ajax.post(`/tripartite/data/${definitionId}`, p),
		update: (definitionId, p) => Ajax.put(`/tripartite/data/${definitionId}`, p),
		delete: (definitionId, id) => Ajax.delete(`/tripartite/data/${definitionId}/${id}`),
		batchDelete: (definitionId, ids) => Ajax.post(`/tripartite/data/${definitionId}/batch-delete`, { ids }),
		importData: (definitionId, formData) => Ajax.post(`/tripartite/data/${definitionId}/import`, formData),
		generateVoucher: (definitionId, p) => Ajax.post(`/tripartite/data/${definitionId}/generate-voucher`, p)
	}
};
